export const BD_GET_PRODUCTS_LISTING = "BD_GET_PRODUCTS_LISTING"
export const BD_GET_PRODUCTS_LISTING_SUCCESS = "BD_GET_PRODUCTS_LISTING_SUCCESS"
export const BD_GET_PRODUCTS_LISTING_FAILED = "BD_GET_PRODUCTS_LISTING_FAILED"

export const BD_PRODUCT_EDIT = "BD_PRODUCT_EDIT"
export const BD_PRODUCT_EDIT_SUCCESS = "BD_PRODUCT_EDIT_SUCCESS"
export const BD_PRODUCT_EDIT_FAIL = "BD_PRODUCT_EDIT_FAIL"
